import { nanoid } from "nanoid";
import { v4 as uuidv4 } from "uuid";
import assets from "../utils/assets";
import { ref, getStorage, getDownloadURL } from "@firebase/storage"

export function formatDate(date, format) {
  let dateStr;
  if (format == 'title') {
    dateStr = date.getHours() + ':' + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes()) + ' ' + date.toLocaleString('default', { month: 'short' }) + ' ' + date.getDate() + ', `' + date.getFullYear().toString().slice(2)
  }

  return dateStr;
}

export const sortTakes = (takes) => {
  if (!takes || takes.length === 0) return takes;
  return takes.sort((a, b) => {
    let timeA = a.modified_at || a.uploaded_at;
    let timeB = b.modified_at || b.uploaded_at;
    if (timeA && !timeB) return 1;
    if (!timeA && timeB) return -1;
    if (!timeA && !timeB) return 1;
    return timeB.seconds - timeA.seconds;
  });
};

export const sortShots = (shots, parts) => {
  if (!parts || parts.length === 0) return shots;
  const masterOrder = parts.flatMap(part => part.order);

  return [...shots].sort((a, b) => {
    const indexA = masterOrder.indexOf(a.id);
    const indexB = masterOrder.indexOf(b.id);

    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });
}

export const emptyStory = (portal_id, include_shot, generate) => {
  const created = new Date();
  const first_shot = uuidv4();
  const includeShot = include_shot ? true : false;
  const generateStory = generate ? true : false;

  return {
    parts: [{ title: "Storyboard", order: includeShot ? [first_shot] : [] }],
    last_cut: null,
    title: formatDate(created, "title"),
    portal_id: portal_id || nanoid(12),
    created_at: created,
    deleted_at: null,
    generated: generateStory,
    shots: includeShot ? [{
      header: "Shot 1",
      description: "HERO starts JOURNEY",
      meta: null,
      // here
      image: assets["empty_thumbnail"],
      // image:
      //   "https://storage.googleapis.com/v0zebra.appspot.com/resource/shot_type/wide.png",
      id: first_shot,
      deleted_at: null,
    }] : [],
  };
};

export const getVideoDuration = (videoUrl) => {
  if (!videoUrl || typeof videoUrl !== 'string') {
    return Promise.reject(new Error('Invalid video URL'));
  }

  return new Promise((resolve, reject) => {
    const video = document.createElement('video');

    // Add timeout to prevent hanging
    const timeout = setTimeout(() => {
      reject(new Error('Video loading timed out'));
    }, 30000); // 30 second timeout

    video.src = videoUrl;

    video.addEventListener('loadedmetadata', () => {
      clearTimeout(timeout);
      const durationInSeconds = Math.floor(video.duration);
      resolve(durationInSeconds);
    });

    video.addEventListener('error', (error) => {
      clearTimeout(timeout);
      reject(new Error(`Failed to load video: ${error.message}`));
    });
  });
};

export const getFormattedDuration = async (videoUrl) => {
  const seconds = await getVideoDuration(videoUrl);
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};

export const calculateAudioStartTime = (shots, takes, currentShotIndex) => {
  if (!shots.length || !takes.length) return;
  const cumulativeDuration = shots
    .slice(0, currentShotIndex)
    .map(shot => {
      const selectedTakeId = shot.selected_take_id || shot.last_take_id;
      const take = takes.find(take => take.id === selectedTakeId)
      return takes.find(take => take.id === selectedTakeId) ? takes.find(take => take.id === selectedTakeId).dur_ms : 0; // Use the first take's duration or 0 if none
      //return Math.min(takeDuration, shot.tgt_dur_ms || takeDuration); // Use shot's target duration or take duration
    })
    .reduce((sum, dur) => sum + dur, 0);
  return cumulativeDuration / 1000; // Convert ms to seconds
};

export const getAudioUrl = async (audioPath) => {
  if (!audioPath) return null;;
  try {
    const storage = getStorage();
    const audioRef = ref(storage, audioPath);
    const url = await getDownloadURL(audioRef);
    return url;
  } catch (error) {
    console.error("Error getting audio URL:", error);
    return null;
  }
};

export const getImageUrl = async (imagePath) => {
  if (!imagePath) return null;
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) return imagePath;
  try {
    const storage = getStorage();
    const imageRef = ref(storage, imagePath);
    const url = await getDownloadURL(imageRef);
    return url;
  } catch (error) {
    console.error("Error getting image URL:", error);
    return null;
  }
};
export const getMediaUrl = async (mediaPath) => {
  if (!mediaPath) return null;
  if (mediaPath.startsWith('http://') || mediaPath.startsWith('https://')) return mediaPath;
  try {
    const storage = getStorage();
    const imageRef = ref(storage, mediaPath);
    const url = await getDownloadURL(imageRef);
    return url;
  } catch (error) {
    console.error("Error getting image URL:", error);
    return null;
  }
};
